module.exports = __webpack_public_path__ + "img/straight-rail-diagonal-right-bottom-stone-path-remnants.f21b65d1.png";